export const background = '#F6F8FA';
